import {
  InterviewsListGridData,
  InterviewsListPersistedPagination
} from './interviews-list.models';

export function getPaginationPage(pagination: InterviewsListPersistedPagination): number {
  if (pagination.page) {
    return pagination.page;
  }
  return Math.floor(pagination.firstRowOffset / pagination.pageSize) + 1;
}

export function getMatchingGridData(
  gridData: InterviewsListGridData | null,
  pagination: InterviewsListPersistedPagination,
  requestedPage: number
): InterviewsListGridData | null {
  if (!gridData || getPaginationPage(pagination) !== requestedPage) {
    return null;
  }
  return gridData;
}
